import { ChangeEvent, useContext, useEffect, useId, useRef } from 'react';
import styles from './RadioOption.module.scss';
import clsx from 'clsx';
import { RadioInputContext } from './RadioInputContext';
import { FormContext } from '../form/FormContext';

interface Props {
  disabled?: boolean;
  label: string;
  value: string;
  selected?: boolean;
}

export function RadioOption({ disabled, label, value }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const id = useId();
  const radioInputContext = useContext(RadioInputContext);
  const formContext = useContext(FormContext);

  useEffect(() => {
    const name = radioInputContext.name,
      input = inputRef.current,
      map = formContext?.inputs;
    if (name && input) {
      const prev = map.get(name) ?? [];
      map.set(name, [...prev, input]);
    }
  }, [formContext, radioInputContext]);

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) {
      radioInputContext.onValue?.(value);
    }
  }

  return (
    <label className={clsx(styles['radio-option'])} htmlFor={id}>
      <span>{label}</span>
      <input
        ref={inputRef}
        defaultChecked={radioInputContext.selectedValue === value}
        disabled={disabled}
        id={id}
        name={radioInputContext.name}
        onChange={onChange}
        type="radio"
        value={value}
      />
    </label>
  );
}
